import * as actionTypes from '../actions/actionTypes';
import { updateObject } from './../../../../shared/utils';

const initialState = {
  controlConfiguration: null,
  controlConfigurationError: null,
  controlConfigurationLoading: false,
  verifyFolderStructureResult: null,
  verifyFolderStructureError: null,
  verifyFolderStructureLoading: false,
};

const getFilesControlConfigurationStart = (state, action) => {
  return updateObject(state, {
    controlConfiguration: null,
    controlConfigurationError: null,
    controlConfigurationLoading: true,
  });
};

const getFilesControlConfigurationSuccess = (state, action) => {
  return updateObject(state, {
    controlConfiguration: action.controlConfiguration,
    controlConfigurationError: null,
    controlConfigurationLoading: false,
  });
};

const getFilesControlConfigurationFail = (state, action) => {
  return updateObject(state, {
    controlConfiguration: null,
    controlConfigurationError: action.error,
    controlConfigurationLoading: false,
  });
};

const verifyFolderStructureStart = (state, action) => {
  return updateObject(state, {
    verifyFolderStructureResult: null,
    verifyFolderStructureError: null,
    verifyFolderStructureLoading: true,
  });
};

const verifyFolderStructureSuccess = (state, action) => {
  return updateObject(state, {
    verifyFolderStructureResult: action.verifyFolderStructureResult,
    verifyFolderStructureError: null,
    verifyFolderStructureLoading: false,
  });
};

const verifyFolderStructureFail = (state, action) => {
  return updateObject(state, {
    verifyFolderStructureResult: null,
    verifyFolderStructureError: action.error,
    verifyFolderStructureLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_FILES_CONTROL_CONFIGURATION:
      return getFilesControlConfigurationStart(state, action);
    case actionTypes.GET_FILES_CONTROL_CONFIGURATION_SUCCESS:
      return getFilesControlConfigurationSuccess(state, action);
    case actionTypes.GET_FILES_CONTROL_CONFIGURATION_FAIL:
      return getFilesControlConfigurationFail(state, action);

    case actionTypes.VERIFY_FOLDER_STRUCTURE:
      return verifyFolderStructureStart(state, action);
    case actionTypes.VERIFY_FOLDER_STRUCTURE_SUCCESS:
      return verifyFolderStructureSuccess(state, action);
    case actionTypes.VERIFY_FOLDER_STRUCTURE_FAIL:
      return verifyFolderStructureFail(state, action);

    default:
      return state;
  }
};

export default reducer;
